module.exports = __webpack_public_path__ + "static/live365-logo-white-c53ab84bdf49c62d58eb198b239ae27f.svg";